
  import React from "react"
  import Component from "/Users/yvettezhang/Documents/FSA/practice/Portfolio/gatsby-site/src/layouts/index.js"
  import data from "/Users/yvettezhang/Documents/FSA/practice/Portfolio/gatsby-site/.cache/json/layout-index.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/index.js